<template>
  <v-card>
    <div class="editor">
      <MainMenu :editor="editor" />
      <editor-content class="editor__content" :editor="editor" />
    </div>
  </v-card>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import { mapMutations, mapGetters } from 'vuex';
import MainMenu from '@/components/TextEditor/MainMenu'
import Placeholder from '@tiptap/extension-placeholder'
import TextAlign from '@tiptap/extension-text-align'
import StarterKit from '@tiptap/starter-kit'
export default {
  components: {
    EditorContent,
    MainMenu,
  },
  props: {
    text: String,
  },
  computed : {
    ...mapGetters(
      'sharedStoryDescription', [
        'getText',
      ],
    )
  },
  methods: {
    ...mapMutations(
      'sharedStoryDescription', [
        'setText',
      ]
    ),
  },
  data() {
    return {
      editor: null,
    }
  },
  mounted() {
    this.editor = new Editor({
        content: this.getText,
        onUpdate: ({ editor }) => {
          this.setText(editor.getHTML())
        },
        extensions: [
          StarterKit,
          TextAlign,
          Placeholder.configure({ placeholder: this.$t("chapter.placeholder") }),
        ],
      })
  },
  beforeDestroy() {
    this.editor.destroy()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .ProseMirror p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  float: left;
  color: #ced4da;
  pointer-events: none;
  height: 0;
}
</style>